import "./AgentMapModal.scss";
import Close from "../../images/close-light.svg";
import Box from "@mui/material/Box";
import { useState } from "react";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

//fake toronto markers
const torontoMarkers = [
  { id: "marker2", position: { lat: 43.654208, lng: -79.389315 }, zone: 1 },
  { id: "marker3", position: { lat: 43.658535, lng: -79.532871 }, zone: 3 },
  { id: "marker4", position: { lat: 43.662112, lng: -79.62577 }, zone: 5 },
  { id: "marker5", position: { lat: 43.654994, lng: -79.337544 }, zone: 1 },
  { id: "marker6", position: { lat: 43.780114, lng: -79.582831 }, zone: 3 },
  { id: "marker7", position: { lat: 43.638684, lng: -79.499974 }, zone: 1 },
  { id: "marker8", position: { lat: 43.834407, lng: -79.387295 }, zone: 2 },
  { id: "marker9", position: { lat: 43.821521, lng: -79.404619 }, zone: 5 },
  { id: "marker12", position: { lat: 43.700955, lng: -79.42565 }, zone: 3 },
  { id: "marker13", position: { lat: 43.811222, lng: -79.489213 }, zone: 2 },
  { id: "marker14", position: { lat: 43.806257, lng: -79.325946 }, zone: 3 },
  { id: "marker15", position: { lat: 43.723348, lng: -79.372133 }, zone: 4 },
  { id: "marker16", position: { lat: 43.62153, lng: -79.608273 }, zone: 2 },
  { id: "marker17", position: { lat: 43.752738, lng: -79.31189 }, zone: 5 },
  { id: "marker18", position: { lat: 43.589886, lng: -79.510814 }, zone: 2 },
  { id: "marker19", position: { lat: 43.781304, lng: -79.628434 }, zone: 5 },
  { id: "marker20", position: { lat: 43.644749, lng: -79.463259 }, zone: 3 },
  { id: "marker24", position: { lat: 43.737072, lng: -79.565733 }, zone: 2 },
  { id: "marker25", position: { lat: 43.775884, lng: -79.302197 }, zone: 5 },
];

export default function AgentMapModal({ handleClose, open }) {
  const [markers, setMarkers] = useState(torontoMarkers);
  const [zone, setZone] = useState("0");

  //set the zone based on the markers
  const changeZone = (e) => {
    const selectedZone = e.target.value;
    setZone(selectedZone);

    const filteredMarkers =
      selectedZone === "0"
        ? torontoMarkers
        : torontoMarkers.filter(
            (marker) => marker.zone.toString() === selectedZone
          );

    setMarkers(filteredMarkers);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            <div className="d-flex justify-content-between pb-3">
              <div className="transaction-selector">
                <div>
                  <label className="selector-label-title">Zones</label>
                </div>
                <select
                  value={zone}
                  onChange={changeZone}
                  className="select-style"
                >
                  <option value="0"> All Zones</option>
                  <option value="1">Zone 1</option>
                  <option value="2">Zone 2</option>
                  <option value="3">Zone 3</option>
                  <option value="4">Zone 4</option>
                  <option value="5">Zone 5</option>
                </select>
              </div>
              <img className="pointer" src={Close} onClick={handleClose} loading="lazy" />
            </div>
            {/* <GoogleMapsAgents markers={markers} /> */}
            {/* <CustomMap /> */}
          </div>
        </Box>
      </Modal>
    </div>
  );
}